const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

export const startLoading = self => {
  return self.$loading.show({
    color: VUE_APP_SPINNER_COLOR
  });
};
